import React, { useState, useEffect, useRef, useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
// COMPONENTS
import { Typography } from "antd";
import ReactPaginate from "react-paginate";
// MANUAL COMPONENTS
import Table from "../Components/Common/Table/Table.js";
// FUNCTIONS
import * as Functions from "../Functions/Functions.js";
import { getToken } from "../Functions/Functions";
import api from "../api/axios.js";

function Notifications(props) {
  // const data = React.useMemo(() => makeData(10), []);
  //Resultados por pagina.
  const navigate = useNavigate();
  const [objPerPage, setObjPerPage] = useState(10); // Resultados por pagina.
  const [pagePressed, setPagePressed] = useState(1); // Pagina clicada estado inicial 0
  const [pageCount, setPageCount] = useState(0); // Numero de paginas estado inicial 0
  const [notifications, setNotifications] = useState([]);
  const { Text } = Typography;

  // PROGRESS BARR
  const [progress, setProgress] = useState(0);
  const [buffer, setBuffer] = useState(10);
  const progressRef = useRef(() => {});

  ///////////////////////////////////////////////////////////////////
  // GET CONTACTS
  const getNotifications = async (token, actualUrl) => {
    try {
      let url =
        actualUrl +
        "/crm_companies_notifications_messages?token=" +
        token +
        "&objPerPage=" +
        objPerPage +
        "&pagePressed=" +
        pagePressed;
      await api.post(url).then((response) => {
        let dataNotifications =
          response.data["crm_companies_notifications_messages"];
        let notificationsCount = response.data["notificationsCount"];
        // numero de paginas
        let pageCountBef = Math.ceil(notificationsCount / objPerPage);
        pageCountBef = pageCountBef - 1; // sale una pagina de mas por eso el -1
        setPageCount(pageCountBef);
        setNotifications(dataNotifications);

        return dataNotifications;
      });
    } catch (error) {
      console.log(error, "error getNotifications");
    }
  };

  useEffect(() => {
    var data = sessionStorage.getItem("token");
    console.log(data, "Loading data...");

    if (
      data !== undefined &&
      data != [] &&
      data !== null &&
      data.length !== 0
    ) {
      const actualUrl = process.env.REACT_APP_BACKEND_HOST || "";

      console.log("Loading getNotifications...");
      getNotifications(data, actualUrl);
    } else {
      console.log("leaving...");
      sessionStorage.clear("token");

      navigate("/");
      // getData();
    }
  }, [pagePressed]);

  // TABLA
  const columns = useMemo(
    () => [
      {
        Header: `LISTA DE NOTIFICACIONES`,
        columns: [
          {
            Header: "Email Origen",
            accessor: "from",
          },
          {
            Header: "email Destinatario",
            accessor: "to",
          },
          {
            Header: "fecha Envio",
            accessor: "||",
          },
          {
            Header: "Asunto",
            accessor: "subject",
          },
          {
            Header: "Mensaje",
            accessor: "message",
          },
          {
            Header: "Ver/editar",
            accessor: "id",
            Cell: (row) => {
              // console.log(row);
              // row.style.color = 'white';
              let contenido = (
                <div>
                  <NavLink
                    to={"/contactos/ver-contacto?contact=" + row.value}
                    style={{
                      textDecoration: "none",
                      color: "white",
                    }}
                  >
                    <button className="greenButton" style={{ margin: "5px" }}>
                      Ver
                    </button>
                  </NavLink>
                  <NavLink
                    to={"/contactos/editar-contacto?contact=" + row.value}
                    style={{
                      textDecoration: "none",
                      color: "white",
                    }}
                  >
                    <button className="greenButton" style={{ margin: "5px" }}>
                      Editar
                    </button>
                  </NavLink>
                </div>
              );
              return contenido;
            },
          },
        ],
      },
    ],
    [],
  );
  // CONTROL PAGINACIÓN
  const handlePageClick = (event) => {
    setPagePressed(event.selected + 1);
  };
  // PAGINATION

  return (
    <div className="fatherContainer">
      <div className="viewHead">
        <h2 className="title">Notificaciones</h2>
        <Text className="paragraph">
          <a href="/" style={{ textDecoration: "none", color: "black " }}>
            Inicio
          </a>{" "}
          / <b> Notificaciones </b>
        </Text>
      </div>
      <div className="mainContainer">
        <Table
          columns={columns}
          data={notifications}
          view={"notificacion"}
          viewTitle={"notificaciones"}
        />
        <ReactPaginate
          name={"paginationName"}
          previousLabel={"🢀"}
          nextLabel={"🢂"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={pageCount}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          pageLinkClassName={"pageName"}
          activeClassName={"active"}
        />
      </div>
    </div>
  );
}

export default Notifications;
